export enum EventType {
    SearchSubmitted = "SearchSubmitted",
    ResultClicked = "ResultClicked",
    ConversationAction = "ConversationAction",
    MessageAction = "MessageAction",
    ToolCallAction = "ToolCallAction",
    PromptSuggestionAction = "PromptSuggestionAction",
}
